import { hasItems } from "../../../helpers/utils";
import moment from "moment";

export const getNewRoutineModel = () => {
  return {
    hours: "[]",
    timeslots: [],
    time_interval: "day",
  };
};

export const getHoursModel = (elem, hours, timeUnit) => {
  return {
    id_activity: elem.item_id,
    hours: timeUnit == "week" ? hours / 7 : hours,
    total_hours: timeUnit == "week" ? hours : hours * 7,
  };
};

export const getHoursFromTimeslots = (timeslots, selectedDay) => {
  let hours = {};
  timeslots.forEach((t) => {
    if (t.activity && t.activity.id) {
      const hm = hours[t.activity.id];

      let spillover = 0;
      if (t.startDate && t.time) {
        const startDay = t.time.substring(0, 10);
        const endDay = t.endDate.substring(0, 10);
        if (startDay != endDay) {
          if (startDay < selectedDay) {
            spillover += moment(t.time).diff(
              moment(selectedDay + " 00:00:00"),
              "minutes",
            );
          }
          if (endDay > selectedDay) {
            spillover += moment(selectedDay + " 24:00:00").diff(
              moment(t.endDate),
              "minutes",
            );
          }
        }
      }

      const model = getHoursModel(
        {
          item_id: t.activity.id,
        },
        (t.duration + spillover) / 60,
        "day",
      );
      if (hm == null) {
        hours[t.activity.id] = model;
      } else {
        hm.hours += model.hours;
        hm.total_hours += model.total_hours;
      }
    }
  });

  const totalHours = [];
  Object.keys(hours).forEach((i) => {
    const h = hours[i];
    h.hours = h.hours.toFixed(4); //toFixed() used for reducing transported json size
    h.total_hours = h.total_hours.toFixed(4);
    totalHours.push(h);
  });

  return totalHours;
};

export const getHoursFromReflections = (reflections, dayIndex, timeUnit) => {
  const hours = {};
  _extractRoutinesElements(reflections, hours);

  const data = [];
  Object.values(hours).forEach((elem) => {
    const hours = hasItems(elem.children)
      ? 0
      : elem.days && elem.days[dayIndex]
      ? elem.days[dayIndex].hours
      : 0;

    if (hours > 0) {
      data.push(RoutinesHelper.getHoursModel(elem, hours, timeUnit));
    }
  });

  return data;
};

const _extractRoutinesElements = (data, hours) => {
  if (data != null) {
    data.forEach((it) => {
      if (it.item_id !== "resolution") {
        if (
          it.item_id != null &&
          (it.children == null || it.children.length === 0)
        ) {
          hours[it.item_id] = it;
        }
        _extractRoutinesElements(it.children, hours);
      }
    });
  }
};

const RoutinesHelper = {
  getNewRoutineModel,
  getHoursModel,
  getHoursFromTimeslots,
  getHoursFromReflections,
};

export default RoutinesHelper;
